import {
  get,
  post
} from './http'

const apiBasicUrl = 'http://restaurant.fastorder.my'

// http: //restaurant.fastorder.my/app/index.php?i=2&c=entry&storeid=44&from_user=ox5R_1eFnFRZ1J5PMrDV5FEDqq_o&do=UpdateDishNumOfCategory&m=weisrc_dish
// #说明 get部分 {i: 2  c: entry  storeid: 44  from_user: ox5R_1eFnFRZ1J5PMrDV5FEDqq_o  do :UpdateDishNumOfCategory  m: weisrc_dish  }
// #说明 post部分 {  dishid: 1242  optionid: 309  o2uNum: 1  optype: add}
export const addToShoppingCart = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)
export const getToShoppingCart = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)
export const delToShoppingCart = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)
export const clsToShoppingCart = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)
